export default __webpack_public_path__ + "static/media/5.68cc4dd8.png";